import React, { useContext, useEffect } from 'react';
import {
  Box, Container, Divider,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ExpandMoreRounded } from '@mui/icons-material';
import AlertContext from '../../../../Context/AlertContext';
import Elements from '../../../Elements';
import Images from '../../../../Configs/images';

export default function Component({
  classes, error, message,
}) {
  const navigate = useNavigate();
  const { openAlert } = useContext(AlertContext);

  useEffect(() => {
    if (error) {
      openAlert({
        message: `Something went wrong. ${message}`,
        severity: 'error',
      });
    }
  }, [error]);

  return (
    <Elements.PageBase navigate={navigate} noNav>
      <Box className={classes.root}>
        <Elements.Navigator title="Transaction history" />

        <Box mt={1}>
          <Container>
            <Box
              display="flex"
              gap={1}
              overflow="auto"
              sx={{
                '::-webkit-scrollbar': {
                  display: 'none',
                },
                '-ms-overflow-style': 'none',
                scrollbarWidth: 'none',
              }}
            >
              <Box display="inline-flex" className="link" gap={1} py={0.5} px={1} borderRadius="8px" alignItems="center" border="1px solid #E5E5E5">
                <Box className="weight-600" whiteSpace="nowrap">By date</Box>
                <ExpandMoreRounded />
              </Box>
              <Box display="inline-flex" className="link" gap={1} py={0.5} px={1} borderRadius="8px" alignItems="center" border="1px solid #E5E5E5">
                <Box className="weight-600" whiteSpace="nowrap">Service</Box>
                <ExpandMoreRounded />
              </Box>
              <Box display="inline-flex" className="link" gap={1} py={0.5} px={1} borderRadius="8px" alignItems="center" border="1px solid #E5E5E5">
                <Box className="weight-600" whiteSpace="nowrap">Payment method</Box>
                <ExpandMoreRounded />
              </Box>
            </Box>
            <Box>
              <Box className="weight-700" mt={2}>Friday, 12 Aug 2022</Box>
              <Box display="flex" gap={1} mt={2} pl={1} onClick={() => navigate('contoh')}>
                <img alt="icon" src={Images.IconSubscription} width="16" height="16" />
                <Box flex={1}>
                  <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Box>
                      <div className="s-12 weight-700">Renewal reguler subscription</div>
                      <div className="s-12">Stripe</div>
                    </Box>
                    <Box className="weight-700">
                      -₣100
                    </Box>
                  </Box>
                  <Divider sx={{ mt: 2 }} />
                </Box>
              </Box>
              <Box display="flex" gap={1} mt={2} pl={1}>
                <img alt="icon" src={Images.IconSubscription} width="16" height="16" />
                <Box flex={1}>
                  <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Box>
                      <div className="s-12 weight-700">Renewal reguler subscription</div>
                      <div className="s-12">Stripe</div>
                    </Box>
                    <Box className="weight-700">
                      Canceled
                    </Box>
                  </Box>
                  <Divider sx={{ mt: 2 }} />
                </Box>
              </Box>
              <Box display="flex" gap={1} mt={2} pl={1}>
                <img alt="icon" src={Images.OenoMarket} width="16" height="16" />
                <Box flex={1}>
                  <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Box>
                      <div className="s-12 weight-700">Item sold on market</div>
                      <div className="s-12">Oenowallet</div>
                    </Box>
                    <Box className="weight-700" color="#38AC3D">
                      +₣100
                    </Box>
                  </Box>
                  <Divider sx={{ mt: 2 }} />
                </Box>
              </Box>
              <Box className="weight-700" mt={2}>Friday, 12 Aug 2022</Box>
              <Box display="flex" gap={1} mt={2} pl={1}>
                <img alt="icon" src={Images.IconSubscription} width="16" height="16" />
                <Box flex={1}>
                  <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Box>
                      <div className="s-12 weight-700">Renewal reguler subscription</div>
                      <div className="s-12">Stripe</div>
                    </Box>
                    <Box className="weight-700">
                      -₣100
                    </Box>
                  </Box>
                  <Divider sx={{ mt: 2 }} />
                </Box>
              </Box>
              <Box display="flex" gap={1} mt={2} pl={1}>
                <img alt="icon" src={Images.OenoMarket} width="16" height="16" />
                <Box flex={1}>
                  <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Box>
                      <div className="s-12 weight-700">Item sold on market</div>
                      <div className="s-12">Oenowallet</div>
                    </Box>
                    <Box className="weight-700" color="#38AC3D">
                      +₣100
                    </Box>
                  </Box>
                  <Divider sx={{ mt: 2 }} />
                </Box>
              </Box>
            </Box>
          </Container>
        </Box>

      </Box>
      <Elements.Footer />
    </Elements.PageBase>
  );
}
